import React from 'react';
import styled from 'styled-components';

import { layout } from '@prisjakt/ui-base';

import Clickable from '@prisjakt/ui-clickable';
import ArrowIcon from 'mdi-react/ArrowTopLeftIcon';

type Props = {
  onClick: () => void;
};

export const ExtendSearchButton = (props: Props) => {
  const { onClick } = props;

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    onClick();
  };

  return (
    <Button data-test="ExtendSearchButton" onClick={handleClick}>
      <ArrowIcon size={16} />
    </Button>
  );
};

const Button = styled(Clickable)`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 24px;
  width: 24px;
  background-color: ${p => p.theme.bg.secondary};
  border-radius: 50%;
  color: ${p => p.theme.icons.secondary};
  position: absolute;
  top: 50%;
  right: ${layout.measurements.spacing100};
  transform: translateY(-50%);
  cursor: pointer;

  &:hover {
    background-color: ${p => p.theme.bg.tertiary};
  }
`;
